'use client';
import { useActionState } from "react";
import Form from 'next/form'
import subscribe from '../../lib/newsletter'

const initialTitle = "Hottest Deals, Delivered Straight to Your Inbox";
const afterSubmitTitle = "Thank you!";

const initialState = {
  message: "",
  status: "",
};


export default function Newsletter() {
  const [state, formAction] = useActionState(subscribe, initialState);

  return (
    <section className="bg-gray-50 py-12 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-screen-xl px-5 sm:px-6 lg:px-8">
        {/* Content */}
        <div className="mx-auto flex max-w-xl flex-col items-center text-center">

          <h2 className="mt-6 text-3xl font-medium tracking-normal text-gray-900 sm:mt-8 sm:text-4xl md:tracking-tight lg:text-5xl lg:leading-tight">
            {state.status !== "OK" ? initialTitle : afterSubmitTitle}
          </h2>

          {/* Newsletter signup container */}

          <div className="mt-8 flex w-full flex-col items-center sm:mt-10">
            <div className="relative h-14 w-full max-w-xl rounded-3xl">
              {/* Newsletter signup form */}

              {(state.status !== 'OK') &&
              <>
                <Form
                  action={formAction}
                  className="group rounded-3xl border border-gray-300/70 bg-transparent transition duration-300 ease-in-out"
                >
                  <input
                    type="email"
                    name="email"
                    className="h-14 w-full rounded-3xl border-0 border-transparent bg-white py-3.5 pl-6 pr-36 text-sm leading-5 text-gray-800 transition duration-300 ease-in-out hover:bg-transparent focus:bg-white focus:outline-none focus:ring-2 focus:ring-red-100"
                    required
                    placeholder="Enter your email"
                    autoComplete="email"
                  />
                  <button
                    type="submit"
                    className='absolute right-3 top-1.5 inline-flex h-11 items-center bg-transparent px-4 py-2 text-tiny uppercase tracking-widest text-amber-700 outline-none transition duration-300 ease-in-out before:absolute before:left-0 before:right-auto before:h-6 before:w-px before:bg-gray-300/70 before:transition before:duration-300 before:ease-in-out before:content-[""] hover:text-amber-700 focus:outline-none sm:font-medium md:px-6'
                  >
                    Subscribe
                  </button>
                </Form>
                <span className="text-sm text-red-700">{state?.message}</span>
              </>
            }
          </div>
        </div>
      </div>
      </div>
    </section>

  )
}
